import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { companyId: String, recruitId: String, companyEntryId: String }

  connect() {
  }

  showDetail(event) {
    // 求人行のクリックかどうかをチェック
    if (event.target.closest('[data-action*="recruit-modal#open"]')) {
      // 求人行のクリックの場合は何もしない（モーダルが開く）
      return
    }
    
    
    // 企業詳細情報ページに遷移（EntryのIDを使用）
    if (this.companyEntryIdValue) {
      window.location.href = `/company/${this.companyEntryIdValue}`
    } else if (this.companyIdValue) {
      // フォールバック: 従来のURL
      window.location.href = `/companies_search/company/${this.companyIdValue}`
    } else {
      // フォールバック: 企業名で検索
      const companyName = event.currentTarget.querySelector('h2').textContent.trim()
      window.location.href = `/companies_search/results?company_name=${encodeURIComponent(companyName)}`
    }
  }

  showStudentDetail(event) {
    
    // 学生向け企業詳細ページに遷移（/student/:id）
    if (this.companyEntryIdValue) {
      window.location.href = `/student/${this.companyEntryIdValue}`
    } else if (this.companyIdValue) {
      // フォールバック: 企業IDを使用
      window.location.href = `/student/${this.companyIdValue}`
    } else {
      // フォールバック: 企業名で検索
      const companyName = event.currentTarget.querySelector('h2').textContent.trim()
      window.location.href = `/jobseeker/students?company_name=${encodeURIComponent(companyName)}`
    }
  }
}
